import { User } from 'lucide-react'
import { useLocation } from 'react-router'

import { appHref } from '@/config/config'
import { trackMarketingCta } from '@/lib/analytics'
import { PRODUCT_NAV_ITEMS } from '../content/productNavItems'
import { NavBar } from './NavBar'

export function SiteNav() {
  const { pathname } = useLocation()
  const onInsurancePage = pathname === '/insurance'
  const onHowWeUseAiPage = pathname === '/how-we-use-ai'
  const onHomePage = pathname === '/'

  return (
    <NavBar
      theme="light"
      navLinks={[
        {
          label: 'About',
          active: onHowWeUseAiPage,
          items: [
            { label: 'Our story', href: '/#about' },
            { label: 'How we use AI', href: '/how-we-use-ai' },
          ],
        },
        {
          label: 'Products',
          active: onInsurancePage,
          items: PRODUCT_NAV_ITEMS,
        },
        { label: 'Blog', href: 'https://blog.cai.ai', external: true },
      ]}
      phoneNumber="(770) 765-0331"
      onPhoneClick={() => trackMarketingCta('nav_phone')}
      utilityLinks={[
        {
          label: 'Login',
          icon: <User />,
          href: appHref('/insure'),
          onClick: () => trackMarketingCta('nav_login', { destination: appHref('/insure') }),
        },
      ]}
      ctaLabel={onHomePage ? undefined : 'Get your quotes'}
      ctaHref={appHref('/application/start')}
      onCtaClick={() => trackMarketingCta('nav_get_quotes', { destination: appHref('/application/start') })}
      ctaNeutralOverSelector="#hero"
    />
  )
}
